import {
  Box,
  Card,
  Checkbox,
  List,
  ListItem,
  makeStyles,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  Fade
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { deleteStaff } from 'src/features/staffSlice';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { useDispatch } from 'react-redux';
import LoadingComponent from 'src/app/components/Loading';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import EditStaff from './EditStaff';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '6px'
  }
}))(TableCell);

const Results = ({ listStaff, getListStaffRef, params, setParams }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.staffSlice.isLoading);
  const totalStaffs = useSelector(state => state.staffSlice.totalStaffs);
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState();
  const [itemCurrent, setItemCurrent] = useState();
  const [rowsSelected, setRowsSelected] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const staffMembers = Array.isArray(listStaff) ? listStaff : [];

  const handleClickMenu = (event, staff) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent(staff);
    setSelectedItem(staff.id);
  };
  const [openEditModal, setOpenEditModal] = useState(false);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const handleEditStaff = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const closeModal = () => {
    setOpenEditModal(false);
  };

  const handleDeleteStaff = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDeleteMultiStaff = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const confirmDelete = () => {
    const listId = rowsSelected?.length > 0 ? rowsSelected : [selectedItem];
    setRowsSelected([]);
    dispatch(closeDialogConfirm());
    listId.forEach(id => dispatch(deleteStaff({ id })));
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListStaffRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListStaffRef(newparams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };
  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (
      staffMembers.length > 0 &&
      rowsSelected.length !== staffMembers.length
    ) {
      const all = staffMembers.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  return (
    <>
      {openEditModal && (
        <EditStaff
          open={openEditModal}
          staff={itemCurrent}
          onClose={closeModal}
        />
      )}

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_STAFF}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_STAFF}
        callbackOk={() => confirmDelete()}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />

      <Card className={clsx(classes.root)}>
        <div>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1050}
                style={{ fontSize: '14px', padding: '6px 4px' }}
              >
                <span>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                <span
                  onClick={handleDeleteMultiStaff}
                  className="mx-2 btnDevice"
                  color="primary"
                  variant="outlined"
                  size="small"
                >
                  <img
                    src={`/static/iconSvg/delete-icon.svg`}
                    alt="delete"
                    style={{ paddingRight: '5px', paddingBottom: '4px' }}
                  />
                  <span className="pt-1"> Xóa </span>
                </span>
              </Box>
            </Fade>
          )}
          <PerfectScrollbar>
            {staffMembers && staffMembers.length ? (
              <Box minWidth={1050}>
                <Table>
                  {rowsSelected.length === 0 && staffMembers?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell width={50}>
                          <Checkbox
                            checked={rowsSelected.length > 0}
                            onChange={() => checkAll()}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>Tên nhân viên</StyledTableCell>
                        <StyledTableCell>Số điện thoại</StyledTableCell>
                        <StyledTableCell>Email</StyledTableCell>
                        <StyledTableCell>Địa chỉ</StyledTableCell>
                        <StyledTableCell>Chức vụ</StyledTableCell>
                        <StyledTableCell>Ngày tạo</StyledTableCell>
                        <StyledTableCell></StyledTableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {staffMembers.map((staff, index) => (
                      <TableRow hover key={staff.id}>
                        <StyledTableCell
                          style={{ maxWidth: '20px' }}
                          onClick={() => select(staff?.id)}
                        >
                          <Checkbox
                            checked={checked(staff.id)}
                            onChange={() => select(staff.id)}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.full_name || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.phone || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.email || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.address || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.role?.title || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {staff?.created_at ? new Date(staff.created_at).toLocaleDateString() : '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <span style={{ color: '#AEB1C5' }}>
                            <MoreVertIcon
                              aria-describedby={`menu-device-${staff?.id}`}
                              className={`cursor-pointer hover-red`}
                              onClick={e => handleClickMenu(e, staff)}
                            />
                          </span>

                          <Popover
                            id={`menu-device-${staff.id}`}
                            className="popover-device"
                            open={open && selectedItem === staff.id}
                            anchorEl={anchorEl}
                            onClose={handleCloseMenu}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                          >
                            <Typography>
                              <List>
                                <ListItem
                                  onClick={handleEditStaff}
                                  className="border-bottom list-menu-device cursor-pointer"
                                >
                                  Chỉnh sửa
                                </ListItem>
                                <ListItem
                                  onClick={handleDeleteStaff}
                                  className="cursor-pointer list-menu-device"
                                >
                                  <span class="text-danger"> Xóa </span>
                                </ListItem>
                              </List>
                            </Typography>
                          </Popover>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" class="justify-content-center" />
                <h4> Danh sách trống </h4>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {staffMembers && staffMembers.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalStaffs}
            </Typography>
            <Pagination
              count={Math.ceil(totalStaffs / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
